import { combineReducers } from "redux";

import { USER_LOGOUT } from "../constants/actionTypes";

import lov from "./lov";
import user from "./user";
import users from "./users";
import events from "./events";
import common from "./common";
import policies from "./policies";
import profiles from "./profiles";
import companies from "./companies";
import zones from "./zones";
import scheduler from "./scheduler";
import attributes from "./attributes";
import siteEntranceExit from "./siteEntranceExit";
import homePage from "./homepage";

const appReducer = combineReducers({
  common,
  user,
  siteEntranceExit,
  profiles,
  policies,
  events,
  lov,
  attributes,
  users,
  scheduler,
  companies,
  zones,
  homePage
});

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = {};
  }
  return appReducer(state, action);
};

export default rootReducer;
